import React, { Component } from "react";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../modules/simpleTextArea";
import { mapToObjectDDL } from "../../../common/mapper";

class ReceivingPartDGIInputs extends Component {
  handleInputChange = (name, value) => {
    const { state, onSetState } = this.props;

    onSetState({
      data: {
        ...state.data,
        [name]: value,
      },
    });
  };

  render() {
    return (
      <>
        <div
          className="grid grid-3x grid-mobile-none gap-15px"
          style={{ alignItems: "center" }}
        >
          <div id="grid-1">
            <SimpleInput
              id="input_text_no_sl"
              name="shippingNo"
              label="No. Shipping List (SL)"
              readOnly
              value={this.props.state.data?.shippingNo}
            />
            <SimpleInput
              id="input_text_no_spbm"
              name="noSPBP"
              label="No. SPBM"
              readOnly
              value={this.props.state.noSPBP}
            />
            <SimpleInput
              id="input_text_no_invoice"
              name="noinvoice"
              label="No. Invoice"
              box="onlyNumber"
              // readOnly
              onChange={({ target }) =>
                this.handleInputChange(target.name, target.value)
              }
              value={this.props.state.data.noinvoice}
            />
          </div>
          <div id="grid-2">
            <SimpleInput
              id="input_text_no_penerimaan"
              name="receivedNo"
              box="onlyNumber"
              label="No Penerimaan"
              readOnly
              value={this.props.state.data?.receivedNo}
            />
            <SimpleDate
              id="select_date_tgl_spbm"
              label="Tgl. SPBM"
              disabled
              date={new Date()}
            />
            <SimpleDate
              id="select_date_tgl_sl"
              name="shippingDate"
              label="Tanggal SL"
              disabled
              date={this.props.state.data?.shippingDate}
            />
          </div>
          <div id="grid-3">
            {/* <SimpleInput
              id="input_text_nama_supp"
              name="namasupp"
              label="Nama Supplier"
              value={this.props.state.data?.namaSupplier}
              readOnly
            /> */}
            <SimpleDDL
              id="select_options_ekpedisi"
              box="search"
              name="supplierId"
              label="Nama Supplier"
              isClearable={true}
              mandatory
              errorMessage={this.props.errors.supplierId}
              options={
                this.props.state.dataSupplier
                  ? this.props.state.dataSupplier.map((item) =>
                      mapToObjectDDL(item.supplierName, item.supplierCode)
                    )
                  : []
              }
              value={this.props.state.data.supplierId}
              onChange={(value, { name }) =>
                this.handleInputChange(name, value)
              }
            />
            <SimpleInput
              id="input_text_no_pol_mobil"
              name="carId"
              label="No. Pol Mobil"
              value={this.props.state.data.carId}
              onChange={({ target }) =>
                this.handleInputChange(target.name, target.value)
              }
            />
            <SimpleDDL
              id="select_options_ekpedisi"
              box="search"
              name="expeditionId"
              label="Nama Ekspedisi"
              isClearable={true}
              options={
                this.props.state.expedisiOptions
                  ? this.props.state.expedisiOptions.map((item) =>
                      mapToObjectDDL(item.supplierName, item.supplierCode)
                    )
                  : []
              }
              value={this.props.state.data.expeditionId}
              onChange={(value, { name }) =>
                this.handleInputChange(name, value)
              }
            />
          </div>
        </div>
        <div
          style={{
            display: "grid",
            gap: "15px",
            gridTemplateColumns: "1fr 1fr",
          }}
        >
          <SimpleTextArea
            typeInputCase="normal"
            name="note"
            label="Catatan"
            value={this.props.state.data.note || ""}
            onChange={({ target }) =>
              this.handleInputChange(target.name, target.value)
            }
          />
          {this.props.state.data.expeditionId && (
            <p style={{ justifySelf: "end" }}>
              {this.props.state.data.expeditionId.name}
            </p>
          )}
        </div>
      </>
    );
  }
}

export default ReceivingPartDGIInputs;
